import type { ItemFiltersType } from '@/common/api/types/itemFilters';

export interface ScenarioItemFilters {
  teamIds?: number[];
  noTeamSet?: boolean;
  estimationIds?: number[];
  noEstimateSet?: boolean;
  itemTypeIds?: number[];
  itemStatusIds?: number[];
  needsTeamOrEstimate?: boolean;
  isMLImputed?: boolean;
  unparented?: boolean;
  inDoneSubtree?: boolean;
  searchText?: string;
  objectiveIds?: number[];
  hasObjective?: boolean;
  hasDependencies?: boolean;
  hasPredecessor?: boolean;
  hasSuccessor?: boolean;
  hasEstimate?: boolean;
  noEstimate?: boolean;
  hasProgress?: boolean;
  noProgress?: boolean;
  plannedStartDateTime?: ItemFiltersType['plannedStartDateTime'];
  plannedFinishDateTime?: ItemFiltersType['plannedFinishDateTime'];
  forecastedStartDateTime?: ItemFiltersType['forecastedStartDateTime'];
  forecastedFinishDateTime?: ItemFiltersType['forecastedFinishDateTime'];
  latestFinishDateTime?: ItemFiltersType['latestFinishDateTime'];
  deadlineDateTime?: ItemFiltersType['deadlineDateTime'];
  createdAt?: ItemFiltersType['createdAt'];
  updatedAt?: ItemFiltersType['updatedAt'];
  doneDateTime?: ItemFiltersType['doneDateTime'];
  customFieldFilters?: ItemFiltersType;
  healthLevels?: string[];
}

export const buildScenarioItemFiltersQueryString = (
  filters?: ScenarioItemFilters,
  order?: string,
): string => {
  const params = new URLSearchParams();

  if (filters?.teamIds?.length) params.set('teamIds', filters.teamIds.join(','));
  if (filters?.noTeamSet) params.set('noTeamSet', 'true');
  if (filters?.estimationIds?.length) params.set('estimationIds', filters.estimationIds.join(','));
  if (filters?.noEstimateSet) params.set('noEstimateSet', 'true');
  if (filters?.itemTypeIds?.length) params.set('itemTypeIds', filters.itemTypeIds.join(','));
  if (filters?.itemStatusIds?.length) params.set('itemStatusIds', filters.itemStatusIds.join(','));
  if (filters?.needsTeamOrEstimate) params.set('needsTeamOrEstimate', 'true');
  if (filters?.isMLImputed) params.set('isMLImputed', 'true');
  if (filters?.unparented) params.set('unparented', 'true');
  if (filters?.inDoneSubtree) params.set('inDoneSubtree', 'true');
  if (filters?.searchText?.trim()) params.set('searchText', filters.searchText.trim());
  if (order) params.set('order', order);

  const queryString = params.toString();
  return queryString ? `?${queryString}` : '';
};
